module.exports = __webpack_public_path__ + "static/corporates-logos-249029d505e80fc064873f32933e3cba.png";